
import { CategoryModel, ProcessTypeEnum } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { categoriesStore } from '@/libs/categories/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import CategoryDialog from '../components/CategoryDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        CategoryDialog,
    },
})
export default class Categories extends Page {
    @Prop() tenantId!: string;
    @Ref() dialog!: CategoryDialog;
    protected itemsPerPage = 10;
    protected ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;

    get headers() {
        return [
            { text: this.$i18n.t('categories.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('categories.processType'), value: 'processType', align: 'left', sortable: false },
            { text: this.$i18n.t('categories.correctionManagers'), value: 'name', align: 'left', sortable: false },
            { text: '', value: 'aiUseReportGeneration', align: 'left', sortable: false },
            { text: this.$i18n.t('settings.categories.notificationsColumn'), value: 'categoryAlerts', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }

    get loading(): boolean {
        return categoriesStore.useGetter(CrudGetter.Pending);
    }

    get categories(): CategoryModel[] {
        return [...categoriesStore.useGetter(CrudGetter.Data)];
    }

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        categoriesStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        return [];
    }

    getPayload() {
        return createCrudQueryPayload<CategoryModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: CategoryModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
